<template>
    <div :class="['box', { active: isCurrent }]">
        <div v-if="!plan.isFree" class="image">
            <svg-vue :icon="`${plan.slug}-plan`" />
        </div>
        <div :class="['content', 'flex', {free: plan.isFree}]">
            <div class="plan-wrapper flex">
                <plan-header
                    :is-current="isCurrent"
                    :title="plan.name"
                />
                <plan-features
                    v-if="!plan.isFree"
                    :features="plan.features"
                />
                <p
                    v-else
                    class="free-plan-text"
                >
                    Get free access to our Single Track Player with limited customizations and email support.
                </p>
            </div>
            <plan-change-button
                v-if="!isCurrent"
                :plan="plan"
                :show="show"
            />
        </div>
    </div>
</template>

<script>
import PlanChangeButton from './PlanChangeButton';
import PlanHeader from './PlanHeader';
import PlanFeatures from '.././PlanFeatures';

export default {
    components: {
        PlanChangeButton,
        PlanHeader,
        PlanFeatures,
    },
    props: {
        plan: {
            type: [Object],
            required: true,
        },
        show: {
            type: [Boolean, Object],
            default: () => ({}),
        },
    },
    computed: {
        /**
         * check if this plan is assigned to show
         *
         * @returns {boolean} if plan is currently used
         */
        isCurrent() {
            return this.plan.slug === this.show.plan.slug;
        },
    },
};
</script>
